import { styled } from 'styled-components'

export const StyledLogo = styled.img`
  height: 24px;
  width: 24px;
`
